export const isValidIanaTimeZone = (value) => {
  const tz = String(value || "").trim();
  if (!tz) return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (_err) {
    return false;
  }
};

export const normalizeTimeZoneValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "object" && value.timezone) return String(value.timezone).trim();
  return "";
};

export const getBrowserTimeZone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isValidIanaTimeZone(tz) ? tz : "UTC";
  } catch (_err) {
    return "UTC";
  }
};

export const resolveTimeZone = (...candidates) => {
  for (const candidate of candidates) {
    const normalized = normalizeTimeZoneValue(candidate);
    if (isValidIanaTimeZone(normalized)) {
      return normalized;
    }
  }
  return getBrowserTimeZone();
};

export const toFiniteIntOrNull = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
